import { isRepaymentSettled, repaymentStatusLabel } from "../utils/repaymentStatus";
import { Box, Typography, useTheme } from "@mui/material";
import { tokens } from "../../src/theme";
import { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { format } from "date-fns";
import { Progress, Button, message, Avatar, Modal, Tooltip } from "antd";
import Cookies from "js-cookie";
import React from "react";
import { useHistory } from "react-router-dom";
import adspot_ico from "../../src/assets/img/businessman-receiving-money-after-contract-signing.png";
import HalfPieChartBorrower from "../components/HalfPieChartBorrower";
import TinyLineChartBorrower from "../components/TinyLineChartBorrower";
import PaidPrincipalBorrower from "../components/PaidPrincipalBorrower";
import InterestPaidBorrower from "../components/InterestPaidBorrower";
import { QuestionOutlined } from "@ant-design/icons";
import TableOfferedLoan from "../components/TableOfferedLoan";
import LoanDetails from "./loan/loan-details";
import DashboardAds from "./dashboardads";

const UI = {
  card: {
    background: "var(--br-surface, rgba(255,255,255,0.72))",
    border: "1px solid rgba(148,163,184,0.22)",
    boxShadow: "var(--br-shadow, 0 14px 34px rgba(2,8,23,0.08))",
    backdropFilter: "blur(10px)",
    borderRadius: "var(--br-card-radius, 18px)",
  },
  cardSoft: {
    background: "var(--br-surface, rgba(255,255,255,0.62))",
    border: "1px solid rgba(148,163,184,0.18)",
    boxShadow: "var(--br-shadow, 0 12px 26px rgba(2,8,23,0.06))",
    backdropFilter: "blur(10px)",
    borderRadius: "var(--br-card-radius, 16px)",
  },
  headerTitle: {
    fontFamily: "Manrope, sans-serif",
    fontWeight: 900,
    fontSize: 18,
    color: "rgba(15,23,42,0.88)",
    letterSpacing: "-0.2px",
  },
  headerAction: {
    borderRadius: 999,
    padding: "8px 16px",
    fontSize: 13,
    fontWeight: 900,
    fontFamily: "Manrope, sans-serif",
    border: "1px solid rgba(148,163,184,0.22)",
    background: "var(--br-surface, rgba(255,255,255,0.72))",
    boxShadow: "var(--br-shadow, 0 12px 26px rgba(2,8,23,0.07))",
    cursor: "pointer",
    color: "rgba(15,23,42,0.82)",
  },
  headerActionHover: {
    background:
      "linear-gradient(135deg, var(--br-primary, rgb(14, 90, 165)) 0%, rgb(109, 92, 246) 120%)",
    color: "#fff",
    border: "1px solid rgba(var(--br-primary-rgb, 14,90,165), 0.18)",
    boxShadow: "var(--br-shadow, 0 14px 34px rgba(var(--br-primary-rgb, 14,90,165), 0.18))",
  },
  subLabel: {
    fontFamily: "Manrope, sans-serif",
    fontWeight: 800,
    fontSize: 12,
    color: "rgba(15,23,42,0.50)",
  },
  value: {
    fontFamily: "Manrope, sans-serif",
    fontWeight: 900,
    fontSize: 18,
    color: "rgba(15,23,42,0.88)",
  },
  divider: {
    width: 1,
    height: 44,
    background: "rgba(148,163,184,0.30)",
    borderRadius: 999,
  },
  helpDot: {
    width: 18,
    height: 18,
    borderRadius: 999,
    border: "1px solid rgba(148,163,184,0.55)",
    background: "rgba(241,245,249,0.75)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
};

const useStyles = makeStyles({
  formControl: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    border: `1px solid ##141414`,
  },
});

const getInitials = (name) => {
  const textToSplit = name.split(" ");
  const initials =
    textToSplit?.[0]?.[0].toUpperCase() +
    (textToSplit?.[1]?.[0].toUpperCase() || "");
  return initials;
};

const ContainerActivity = ({ title, subtitle }) => (
  <div
    style={{
      width: "100%",
      textAlign: "left",
      marginBottom: "7px",
      border: "none",
      borderRadius: "var(--br-card-radius, 10px)",
      backgroundColor: "var(--br-surface, #FFFFFFB3)",
    }}
  >
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "8px",
      }}
    >
      <div
        style={{
          width: "40px",
          height: "40px",
          borderRadius: "50%",
          background: "rgb(140,140,170)",
          marginLeft: "10px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          cursor: "pointer",
          color: "white",
          fontSize: 20,
          fontWeight: 600,
        }}
      >
        {title ? getInitials(title) : "SL"}
      </div>
      <div style={{ marginLeft: "5px", width: "calc(100% - 70px)" }}>
        <h3
          style={{
            fontFamily: "Poppins, sans-serif",
            fontWeight: 700,
            fontSize: "13px",
            color: "var(--br-text, #435669)",
            margin: "0px",
          }}
        >
          {title}
        </h3>
        <p
          style={{
            fontFamily: "Manrope, sans-serif",
            fontWeight: "600",
            fontSize: "11px",
            color: "rgba(0,0,0,0.4)",
            margin: "0px",
          }}
        >
          {subtitle}
        </p>
      </div>
    </div>
  </div>
);

// const ContainerLineChart = () => (
//   <div style={{ width: "100%", height: "200px", marginRight: "0px", borderRadius: "20px" }}>
//     <TinyLineChart title="$12,000" subtitle="Net profit to date" />
//   </div>
// );

const formatDate = (dateString) => {
  if (!dateString) return "-"; // Return a default value if the date string is not provided

  const date = new Date(dateString); // Create a Date object from the date string
  const formattedDate = format(date, "MMM dd, yyyy"); // Use date-fns to format the date in the desired format

  return formattedDate;
};

const Dashboard = () => {
  const classes = useStyles();
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [data, setData] = useState([]);
  const [acceptedLoanData, setAcceptedLoan] = useState([]);
  const [dataRequestedLoan, setRequestedLoan] = useState([]);
  const [dataActivityLog, setActivityLog] = useState([]);
  const [dataSummary, setSummary] = useState([]);
  const [loanPeriod, setLoanPeriod] = useState(0);
  const [showAllTransactions, setShowAllTransactions] = useState(false);
  const [offer_amount, setLoanAmount] = useState(0);
  const [offer_period, setSelectedLoanPeriod] = useState(0);
  const [offer_principal, setLoanPrincipal] = useState(0);
  const [offer_monthly_installment, setExpectedMonthlyInstallment] =
    useState(0);
  const [offer_revenue, setGuaranteedRevenue] = useState(0);
  const [type, setLoanType] = useState("simple_loan");
  const [offer_interest_rate, setInterestRate] = useState(0);
  const [total_admin_fee, setTotalAdminFee] = useState(0);
  const [admin_fee, setAdminFee] = useState(0);
  const history = useHistory();
  const [loanDetails, setLoanDetails] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const [loanBalances, setLoanBalances] = useState([]);
  const [totalLoanBalance, setTotalLoanBalance] = useState(0);
  const [totalLoan, setTotalLoan] = useState(null);
  const [countRemainingTerm, setCountRemainingTerm] = useState([]);
  const [sumMaxRemainingTerm, setMaxRemainingTerm] = useState(0);
  const [countInterestRate, setCountInterestRate] = useState([]);
  const [totalCountInterestRate, setTotalCountInterestRate] = useState(0);
  const [makePayment, setMakePayment] = useState();
  const [refreshData, setRefreshData] = useState(false);
  const [offeredLoanDetail, setOfferedLoanDetail] = useState(null);
  const [lenderId, setLenderId] = useState(null);
  const [typeApplicationLoan, setType] = useState(null);
  const [principal, setPrincipal] = useState(null);
  const [amount, setAmount] = useState(null);
  const [period, setPeriod] = useState(null);
  const [monthly_installment, setMonthlyInstallment] = useState(null);
  const [revenue, setRevenue] = useState(null);
  const [express, setExpress] = useState(null);
  const [category, setCategory] = useState(null);
  const [interest_rate, setInterestRateAcceptedLoan] = useState(null);
  const [screenWidth, setScreenWidth] = useState(1920);
  const [isMobile, setIsMobile] = useState(
    Cookies.get("ismobile") === "yes" ? true : false
  );
  useEffect(() => {
    if (screenWidth < 1200) {
      Cookies.set("ismobile", "yes");
      setIsMobile(true);
    } else {
      Cookies.set("ismobile", "no");
      setIsMobile(false);
    }
  }, [screenWidth]);
  const [statusMessage, setStatusMessage] = useState({
    message: "",
    color: "",
  });
  const [hoveredApplyNow, setHoveredApplyNow] = useState(false);


  // if (isMobile) {
  //   return <DashboardMobile />;
  // }

  const handleApplyLoan = (event) => {
    event.preventDefault();
    history.push("/b-loan-hub");
  };

  const handleAcceptedLoan = (event) => {
    event.preventDefault();
    history.push("/b-accepted-loans");
  };

  const resetLoanDetail = () => {
    setOfferedLoanDetail([]);
  };

  const handleRowClick = async (loan_id, offer_id) => {
    console.log("loan_id", loan_id);
    console.log("offer_id", offer_id);

    try {
      const response = await fetch(
        `https://www.smart-lend.com/api/loan/pendingLoan/viewOfferedLoanDetail?loan_id=${loan_id}&offer_id=${offer_id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        }
      );
      const json = await response.json();
      const loanDetail = json["Offered Loans Detail"][0];
      setOfferedLoanDetail(json["Offered Loans Detail"]);
      setLenderId(loanDetail.lender_id); // Set the lender_id in the state
      setType(loanDetail.typeApplicationLoan); // Set the type in the state
      setPrincipal(loanDetail.offer_principal); // Set the principal
      setAmount(loanDetail.offer_amount); // Set the amount in the
      setAdminFee(loanDetail.admin_fee); // Set the admin  fee
      setInterestRateAcceptedLoan(loanDetail.offer_interest_rate); // Set the interest rate
      setPeriod(loanDetail.offer_period); // Set the period
      setMonthlyInstallment(loanDetail.offer_monthly_installment);
      setRevenue(loanDetail.offer_revenue);
      setExpress(loanDetail.express);
      setTotalAdminFee(loanDetail.total_admin_fee);
    } catch (error) {
      console.error("Error retrieving Offered Loans Detail:", error);
    }
  };

  const handleAcceptOffer = async (loan_id) => {
    try {
      let item = {
        loan_id: loan_id,
        lender_id: lenderId,
        type: type,
        express: express,
        category: category,
        principal: principal,
        amount: amount,
        admin_fee: admin_fee,
        total_admin_fee: total_admin_fee,
        interest_rate: interest_rate,
        period: period,
        monthly_installment: monthly_installment,
        revenue: revenue,
      };

      const response = await fetch(
        `https://www.smart-lend.com/api/loan/pendingLoan/acceptLoan`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
          body: JSON.stringify(item),
        }
      );
      const json = await response.json();

      if (response.status === 200) {
        // Here, when the response status is 200, close the modal
        setModalStates((prevStates) => ({
          ...prevStates,
          [loan_id]: false,
        }));

        // Display the message from the Ant Design library
        message.success(json.message);
      } else if (response.status === 400) {
        setStatusMessage({
          message: "You have already accepted this loan.",
          color: "red",
        });
      }
    } catch (error) {
      console.error("Error retrieving Requested Loan Details:", error);
      if (error) {
        setStatusMessage({
          message: "Please click the table row.",
          color: "red",
        });
      }
    }
  };

  const reformatDateString = (originalDateString) => {
    // Create a Date object from the original date string
    const originalDate = new Date(originalDateString);

    // Define options for formatting the date
    const options = { year: "numeric", month: "short", day: "numeric" };

    // Format the date into "Mon dd, yyyy" format
    const formattedDate = originalDate.toLocaleDateString("en-US", options);

    return formattedDate;
  };
  const ChartCard = ({ children }) => (
    <div
      style={{
        ...UI.cardSoft,
        padding: isMobile ? 10 : 12,
        borderRadius: isMobile ? 16 : 16,
        height: isMobile ? 180 : 300, // ✅ compact height on mobile
        overflow: "hidden", // ✅ prevents chart bleed
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
      }}
    >
      {children}
    </div>
  );

  const ContainerPieChart = () => (
    <ChartCard>
      <HalfPieChartBorrower alltheFreakingLoanData={alltheFreakingLoanData} />
    </ChartCard>
  );

  const ContainerLineChart = () => (
    <ChartCard>
      <TinyLineChartBorrower />
    </ChartCard>
  );

  const ContainerPrincipalPaid = () => (
    <ChartCard>
      <PaidPrincipalBorrower alltheFreakingLoanData={alltheFreakingLoanData} />
    </ChartCard>
  );

  const ContainerInterestPaid = () => (
    <ChartCard>
      <InterestPaidBorrower alltheFreakingLoanData={alltheFreakingLoanData} />
    </ChartCard>
  );

  const Container2 = ({
    icon,
    title,
    item,
    subtitle,
    label,
    description,
    label1,
    label2,
    description1,
    description2,
    label3,
    description3,
    index,
    label4,
    repay_id,
  }) => {
    return (
      <div
        style={{
          width: screenWidth < 800 ? "280px" : "27.31vw",
          textAlign: "center",
          border: "1px solid none",
          borderRadius: "var(--br-card-radius, 10px)",
          backgroundColor: "var(--br-surface, #FFFFFFB3)",
          height: screenWidth < 800 ? "auto" : "220px",
          marginRight: "6px",
          padding: "20px",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            flexDirection: screenWidth < 800 ? "column" : "row",
            width: "100%",
            alignItems: screenWidth ? "flex-start" : "center",
            height: screenWidth < 800 ? "auto" : "190px",
          }}
        >
          <div
            style={{
              height: "160px",
              width: screenWidth < 800 ? "100%" : "68%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
            }}
          >
            <p
              style={{
                fontFamily: "Manrope, sans-serif",
                fontWeight: "800",
                fontSize: screenWidth < 800 ? "30px" : "40px",
                textAlign: "left",
                color: "var(--br-text, #142C44)",
                margin: "0px 0px 10px 0px",
                lineHeight: "40px",
              }}
            >
              {description1}
            </p>

            <div
              style={{
                display: "flex",
                flexDirection: screenWidth < 800 ? "column" : "row",
              }}
            >
              <div style={{ display: "flex" }}>
                <p
                  style={{
                    fontFamily: "Manrope, sans-serif",
                    fontWeight: "600",
                    fontSize: "11px",
                    color: "rgba(0,0,0,0.4)",
                  }}
                >
                  {label1}
                </p>
                <p
                  style={{
                    fontFamily: "Manrope, sans-serif",
                    fontWeight: "800",
                    fontSize: "11px",
                    color: "rgba(0,0,0,0.7)",
                  }}
                >
                  {item.repay_principal.toLocaleString("en-US", {
                    style: "currency",
                    currency: "SGD",
                  })}
                </p>
              </div>
              {screenWidth > 800 ? (
                <p
                  style={{
                    fontFamily: "Manrope, sans-serif",
                    fontWeight: "600",
                    fontSize: "11px",
                    color: "rgba(0,0,0,0.4)",
                    margin: "0px 5px",
                  }}
                >
                  |
                </p>
              ) : null}
              <div
                style={{
                  display: "flex",
                  marginTop: screenWidth < 800 ? "-15px" : "0px",
                }}
              >
                <p
                  style={{
                    fontFamily: "Manrope, sans-serif",
                    fontWeight: "600",
                    fontSize: "11px",
                    color: "rgba(0,0,0,0.4)",
                  }}
                >
                  {label2}
                </p>
                <p
                  style={{
                    fontFamily: "Manrope, sans-serif",
                    fontWeight: "800",
                    fontSize: "11px",
                    color: "rgba(0,0,0,0.7)",
                  }}
                >
                  {description2}
                </p>
              </div>
            </div>
            <div style={{ textAlign: "left" }}>
              <p
                style={{
                  fontFamily: "Manrope, sans-serif",
                  fontWeight: "600",
                  fontSize: "11px",
                  color: "rgba(0,0,0,0.4)",
                }}
              >
                {label4}
              </p>
            </div>
          </div>
          <div
            style={{
              height: screenWidth < 800 ? "auto" : "160px",
              textAlign: "left",
              width: screenWidth < 800 ? "100%" : "30%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
              marginTop: screenWidth < 800 ? "20px" : "0px",
            }}
          >
            <p
              style={{
                fontFamily: "Manrope, sans-serif",
                fontWeight: "600",
                fontSize: "11px",
                color: "rgba(0,0,0,0.4)",
                margin: "0px",
              }}
            >
              {label3}
            </p>
            <p
              style={{
                fontWeight: "700",
                fontFamily: "Poppins, sans-serif",
                fontSize: "16px",
                color: "var(--br-text, #142C44CC)",
              }}
            >
              {description3 ? reformatDateString(description3) : null}
            </p>
          </div>
        </div>
      </div>
    );
  };

  const Container4 = ({
    icon,
    title,
    subtitle,
    label,
    description,
    label1,
    label2,
    description1,
    description2,
    label3,
    description3,
    label4,
    description4,
    label5,
    description5,
    index,
    loan_id,
    open_modal,
    cancel_modal,
    onClickModal,
    createdAt,
  }) => {
    const shouldAddMarginTop = index > 3;
    const [hovered, setHovered] = useState(false);

    return (
      <div style={{ width: screenWidth < 800 ? "220px" : "198px" }}>
        <div
          style={{
            width: screenWidth > 1200 ? "100%" : "220px",
            textAlign: "center",
            border: "1px solid white",
            borderRadius: "var(--br-card-radius, 10px)",
            backgroundColor: "var(--br-surface, #FFFFFFB3)",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            cursor: "pointer",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              margin: "0px 15px 0px 15px",
            }}
          >
            {/* <img src={icon} alt={title} style={{ width: "55px", height: "55px", borderRadius: "1000px", border: "2px solid #f0f0f0" }} /> */}
            <div
              style={{
                marginLeft: "15px",
                marginBottom: "10px",
                marginTop: "7px",
                marginRight: "1px",
              }}
            >
              <h3
                style={{
                  fontFamily: "Poppins, sans-serif",
                  fontWeight: "600",
                  fontSize: "18px",
                  textAlign: "left",
                  marginTop: "18px",
                }}
              >
                {title}
              </h3>
              <p
                style={{
                  fontFamily: "Manrope, sans-serif",
                  fontWeight: "800",
                  fontSize: "11px",
                  textAlign: "left",
                  marginTop: "-10px",
                  opacity: ".6",
                  color: "var(--br-text, rgb(20, 44, 68))",
                }}
              >
                {subtitle}
              </p>
            </div>
          </div>
          <div
            style={{
              textAlign: "left",
              marginLeft: "10px",
              margin: "0px 15px 0px 15px",
            }}
          >
            <p
              style={{
                fontFamily: "Poppins, sans-serif",
                fontWeight: "400",
                fontSize: "10px",
                opacity: ".6",
                marginTop: "-3px",
              }}
            >
              {label5}
            </p>
            <p
              style={{
                fontFamily: "Manrope, sans-serif",
                fontWeight: "800",
                fontSize: "18px",
                color: "var(--br-text, rgb(20, 44, 68))",
                marginTop: "-17px",
              }}
            >
              {description5}
            </p>
            <p
              style={{
                fontFamily: "Poppins, sans-serif",
                fontWeight: "400",
                fontSize: "10px",
                opacity: ".6",
                marginTop: "-3px",
              }}
            >
              {label}
            </p>
            <p
              style={{
                fontFamily: "Manrope, sans-serif",
                fontWeight: "800",
                fontSize: "18px",
                color: "var(--br-text, rgb(20, 44, 68))",
                marginTop: "-17px",
              }}
            >
              {description}
            </p>
            <p
              style={{
                fontFamily: "Poppins, sans-serif",
                fontWeight: "400",
                fontSize: "10px",
                opacity: ".6",
                marginTop: "-3px",
              }}
            >
              {label1}
            </p>
            <p
              style={{
                fontFamily: "Manrope, sans-serif",
                fontWeight: "800",
                fontSize: "18px",
                color: "var(--br-text, rgb(20, 44, 68))",
                marginTop: "-17px",
              }}
            >
              {description1}
            </p>
            <p
              style={{
                fontFamily: "Poppins, sans-serif",
                fontWeight: "400",
                fontSize: "10px",
                opacity: ".6",
                marginTop: "-3px",
              }}
            >
              {label4}
            </p>
            <p
              style={{
                fontFamily: "Manrope, sans-serif",
                fontWeight: "800",
                fontSize: "18px",
                color: "var(--br-text, rgb(20, 44, 68))",
                marginTop: "-17px",
              }}
            >
              {description4}
            </p>
            <p
              style={{
                fontFamily: "Poppins, sans-serif",
                fontWeight: "400",
                fontSize: "10px",
                opacity: ".6",
                marginTop: "-3px",
              }}
            >
              {label2}
            </p>
            <p
              style={{
                fontFamily: "Manrope, sans-serif",
                fontWeight: "800",
                fontSize: "18px",
                color: "var(--br-text, rgb(20, 44, 68))",
                marginTop: "-17px",
              }}
            >
              {description2}
            </p>
            <p
              style={{
                fontFamily: "Poppins, sans-serif",
                fontWeight: "400",
                fontSize: "10px",
                opacity: ".6",
                marginTop: "-3px",
              }}
            >
              {label3}
            </p>
            <p
              style={{
                fontFamily: "Manrope, sans-serif",
                fontWeight: "800",
                fontSize: "18px",
                marginTop: "-17px",
                color: "var(--br-text, rgb(20, 44, 68))",
              }}
            >
              {description3}
            </p>
            <p
              style={{
                fontFamily: "Poppins, sans-serif",
                fontWeight: "400",
                fontSize: "10px",
                opacity: ".6",
                marginTop: "-3px",
              }}
            >
              Created At
            </p>
            <p
              style={{
                fontFamily: "Manrope, sans-serif",
                fontWeight: "800",
                fontSize: "18px",
                marginTop: "-17px",
                color: "var(--br-text, rgb(20, 44, 68))",
              }}
            >
              {formatDate(createdAt)}
            </p>
          </div>
          {/* <div>
            <button
              style={{
                fontFamily: "Poppins, sans-serif",
                fontWeight: "600",
                fontSize: "15px",
                color: hovered ? "#ffffff" : "#0E5AA5",
                textAlign: "center",
                background: hovered
                  ? "linear-gradient(90deg, rgba(138, 156, 197, 0.8) 0%, rgba(21,87,169,1) 100%)"
                  : "none",
                border: "1px solid #707070",
                borderRadius: "1000px",
                width: "90%",
                height: "40px",
                marginTop: "5px",
                marginBottom: "15px",
              }}
              onMouseEnter={() => setHovered(true)} // set the state hovered to true  when mouse enter
              onMouseLeave={() => setHovered(false)} // set the state hovered to false  when mouse leave
              onClick={(event) => showModal(loan_id, event)}
            >
              View Offered Loan
            </button>
          </div> */}
        </div>
      </div>
    );
  };

  const Container2Summary = ({ noData }) => {
    return (
      <>
        <div
          style={{
            width: "23.5%",
            textAlign: "center",
            marginRight: "0px",
            marginLeft: "15px",
            border: "1px solid none",
            borderRadius: "var(--br-card-radius, 20px)",
            backgroundColor: "var(--br-surface, #FFFFFFB3)",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <p
            style={{
              fontFamily: "Poppins, sans-serif",
              fontWeight: "600",
              fontSize: "18px",
              color: "var(--br-text, #142C44CC)",
              textAlign: "center",
            }}
          >
            {noData}
          </p>
        </div>
      </>
    );
  };

  const Container3 = ({ noData }) => {
    return (
      <>
        <div
          style={{
            width: screenWidth > 1200 ? "96%" : "100%",
            textAlign: "center",
            height: "240px",
            marginRight: "-15px",
            marginLeft: screenWidth > 1200 ? "25px" : "0px",
            border: "1px solid none",
            borderRadius: "var(--br-card-radius, 10px)",
            backgroundColor: "var(--br-surface, #FFFFFFB3)",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <p
            style={{
              fontFamily: "Poppins, sans-serif",
              fontWeight: screenWidth < 800 ? "400" : "600",
              fontSize: screenWidth < 800 ? "12px" : "18px",
              color: "var(--br-text, #142C44CC)",
              textAlign: "center",
            }}
          >
            {noData}
          </p>
        </div>
      </>
    );
  };

  const Container3Transaction = ({ noData }) => {
    return (
      <>
        <div
          style={{
            width: screenWidth > 1200 ? "96%" : "100%",
            textAlign: "center",
            height: "240px",
            marginRight: "-15px",
            marginLeft: screenWidth > 1200 ? "25px" : "0px",
            border: "1px solid none",
            borderRadius: screenWidth > 1200 ? "10px" : "0px 0px 10px 10px",
            backgroundColor: "var(--br-surface, #FFFFFFB3)",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <p
            style={{
              fontFamily: "Poppins, sans-serif",
              fontWeight: screenWidth < 800 ? "400" : "600",
              fontSize: screenWidth < 800 ? "12px" : "18px",
              color: "var(--br-text, #142C44CC)",
              textAlign: "center",
            }}
          >
            {noData}
          </p>
        </div>
      </>
    );
  };

  const ContainerActivity2 = ({ noData }) => (
    <div
      style={{
        width: "100%",
        textAlign: "left",
        marginBottom: "12.5px",
        border: "1px solid none",
        borderRadius: "var(--br-card-radius, 10px)",
        backgroundColor: "var(--br-surface, #FFFFFFB3)",
        height: "60px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <p
        style={{
          fontFamily: "Poppins, sans-serif",
          fontWeight: screenWidth < 800 ? "400" : "600",
          fontSize: screenWidth < 800 ? "12px" : "16px",
          color: "var(--br-text, #142C44CC)",
          textAlign: "center",
          margin: "0px",
        }}
      >
        {noData}
      </p>
    </div>
  );

  // useEffect(() => {
  //   // To redirect user if not authenticated
  //   const isAuthenticated = Cookies.get("token");
  //   const user_account_type = Cookies.get("user_account_type");

  //   if (!isAuthenticated) {
  //     history.push("/auth/signin");
  //   } else if (user_account_type === "lender") {
  //     history.push("/dashboard");
  //   }

  //   // Checking response of profile picture API
  //   fetch("https://www.smart-lend.com/api/profile/viewInfoProfilePicture")
  //     .then((response) => response.json())
  //     .then((data) => {
  //       if (data.message === "Unauthenticated.") {
  //         history.push("/auth/signin");
  //       }
  //     })
  //     .catch((error) => {
  //       console.error("Error:", error);
  //     });
  // }, [history]);

  useEffect(() => {
    async function fetchData() {
      const headers = new Headers();
      headers.append("Content-Type", "application/json");
      headers.append("Authorization", "Bearer " + Cookies.get("token"));

      const options = {
        method: "GET",
        headers: headers,
      };

      try {
        const response = await fetch(
          "https://www.smart-lend.com/api/dashboard/viewBorrowerTransaction",
          options
        );

        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }

        const data = await response.json();

        setData(data["Latest Transaction"]);
      } catch (error) {
        console.error(error);
      }
    }
    fetchData();
  }, [refreshData]);

  useEffect(() => {
    async function fetchData() {
      const headers = new Headers();
      headers.append("Content-Type", "application/json");
      headers.append("Authorization", "Bearer " + Cookies.get("token"));

      const options = {
        method: "GET",
        headers: headers,
      };

      try {
        const response = await fetch(
          "https://www.smart-lend.com/api/dashboard/viewLoanBalance",
          options
        );

        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }

        const data = await response.json();

        // setLoanBalances(data["loan balances"]);
        calculateTotalLoanBalance(data["loan balances"]);
      } catch (error) {
        console.error(error);
      }
    }
    fetchData();
  }, []);

  useEffect(() => {
    async function fetchData() {
      const headers = new Headers();
      headers.append("Content-Type", "application/json");
      headers.append("Authorization", "Bearer " + Cookies.get("token"));

      const options = {
        method: "GET",
        headers: headers,
      };

      try {
        const response = await fetch(
          "https://www.smart-lend.com/api/loan/pendingLoan/viewAcceptedLoanBorrower",
          options
        );

        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }

        const data = await response.json();

        setAcceptedLoan(data["Accepted Loan"]);
      } catch (error) {
        console.error(error);
      }
    }
    fetchData();
  }, []);
  const [alltheFreakingLoanData, setAllTheFreakingLoanData] = useState(null);

  function calculateTotalLoanBalance(loanData) {
    let sum = 0;
    console.log(loanData);
    setAllTheFreakingLoanData(loanData);
    loanData.forEach((loan) => {
      if (loan.loan_balance !== null) {
        // Check if loan_balance is not null
        // sum += loan.loan_balance;
        console.log(loan);
        for (const rema of loan.remaining) {
          if (!isRepaymentSettled(rema)) {
            sum += rema.repay_amount;
          }
        }
      }
    });
    setTotalLoanBalance(sum);
  }

  useEffect(() => {
    async function fetchData() {
      const headers = new Headers();
      headers.append("Content-Type", "application/json");
      headers.append("Authorization", "Bearer " + Cookies.get("token"));

      const options = {
        method: "GET",
        headers: headers,
      };

      try {
        const response = await fetch(
          "https://www.smart-lend.com/api/dashboard/countTotalLoan",
          options
        );

        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }

        const data = await response.json();

        setTotalLoan(data["Total Loan"][0].total_loan);
      } catch (error) {
        console.error(error);
      }
    }
    fetchData();
  }, []);

  useEffect(() => {
    async function fetchData() {
      const headers = new Headers();
      headers.append("Content-Type", "application/json");
      headers.append("Authorization", "Bearer " + Cookies.get("token"));

      const options = {
        method: "GET",
        headers: headers,
      };

      try {
        const response = await fetch(
          "https://www.smart-lend.com/api/dashboard/countRemainingTerm",
          options
        );

        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }

        const data = await response.json();

        setCountRemainingTerm(data["Remaining Term"]);
        calculateMaxRemainingTerm(data["Remaining Term"]);
      } catch (error) {
        console.error(error);
      }
    }
    fetchData();
  }, []);

  function calculateMaxRemainingTerm(loanData) {
    let maxTerm = 0;
    loanData.forEach((loan) => {
      if (loan.remaining_term > maxTerm) {
        maxTerm = loan.remaining_term;
      }
    });
    setMaxRemainingTerm(maxTerm);
  }

  useEffect(() => {
    async function fetchData() {
      const headers = new Headers();
      headers.append("Content-Type", "application/json");
      headers.append("Authorization", "Bearer " + Cookies.get("token"));

      const options = {
        method: "GET",
        headers: headers,
      };

      try {
        const response = await fetch(
          "https://www.smart-lend.com/api/dashboard/countInterestRate",
          options
        );

        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }

        const data = await response.json();
        console.log("Received data: ", data);

        setCountInterestRate(data["Interest Rate"]);
        calculateTotalInterestRate(data["Interest Rate"]);
      } catch (error) {
        console.error(error);
      }
    }
    fetchData();
  }, []);

  function calculateTotalInterestRate(loanData) {
    let sum = 0;
    loanData.forEach((loan) => {
      sum += loan.interest_rate * 100;
    });
    const average = sum / loanData.length;
    console.log("Calculated average: ", average);
    setTotalCountInterestRate(average.toFixed(1));
  }

  useEffect(() => {
    async function fetchData() {
      const headers = new Headers();
      headers.append("Content-Type", "application/json");
      headers.append("Authorization", "Bearer " + Cookies.get("token"));

      const options = {
        method: "GET",
        headers: headers,
      };

      try {
        const response = await fetch(
          "https://www.smart-lend.com/api/profile/viewActivityLog",
          options
        );

        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }

        const data = await response.json();
        const reversedData = data.reverse();

        setActivityLog(reversedData);
      } catch (error) {
        console.error(error);
      }
    }

    fetchData();
  }, []);

  useEffect(() => {
    async function fetchData() {
      const headers = new Headers();
      headers.append("Content-Type", "application/json");
      headers.append("Authorization", "Bearer " + Cookies.get("token"));

      const options = {
        method: "GET",
        headers: headers,
      };

      try {
        const response = await fetch(
          "https://www.smart-lend.com/api/loan/ongoingLoan/viewOngoingLoan",
          options
        );

        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }

        const data = await response.json();

        setSummary(data["Ongoing Loan"]);
      } catch (error) {
        console.error(error);
      }
    }
    fetchData();
  }, []);

  useEffect(() => {
    const calculateLoan = () => {
      if (type === "simple_loan") {
        const offer_monthly_installment =
          (offer_amount / offer_period +
            offer_amount * (offer_interest_rate / 100)) *
            1.05 || "0";
        const offer_principal = offer_monthly_installment * offer_period || "0";
        const total_admin_fee =
          (offer_amount / offer_period +
            offer_amount * (offer_interest_rate / 100)) *
            0.6 || "0";
        const offer_revenue =
          offer_principal - offer_amount - total_admin_fee || "0";
        const admin_fee = 0.05;
        setAdminFee(admin_fee);
        setLoanPrincipal(offer_principal);
        setExpectedMonthlyInstallment(offer_monthly_installment);
        setGuaranteedRevenue(offer_revenue);
        setTotalAdminFee(total_admin_fee);
      } else if (type === "effective_loan") {
        const offer_monthly_installment =
          ((offer_amount *
            (offer_interest_rate / 1200) *
            (1 + offer_interest_rate / 1200) ** offer_period) /
            ((1 + offer_interest_rate / 1200) ** offer_period - 1)) *
            1.05 || "0";
        const offer_principal = offer_monthly_installment * offer_period || "0";
        const total_admin_fee =
          ((offer_amount *
            (offer_interest_rate / 1200) *
            (1 + offer_interest_rate / 1200) ** offer_period) /
            ((1 + offer_interest_rate / 1200) ** offer_period - 1)) *
            0.6 || "0";
        const offer_revenue =
          offer_principal - offer_amount - total_admin_fee || "0";
        const admin_fee = 0.05;
        setAdminFee(admin_fee);
        setLoanPrincipal(offer_principal);
        setExpectedMonthlyInstallment(offer_monthly_installment);
        setGuaranteedRevenue(offer_revenue);
        setTotalAdminFee(total_admin_fee);
      }
    };
    calculateLoan();
  }, [
    offer_amount,
    offer_interest_rate,
    offer_period,
    type,
    offer_principal,
    offer_monthly_installment,
    offer_revenue,
    total_admin_fee,
    admin_fee,
  ]);

  const fetchLoanDetails = async (loan_id) => {
    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", "Bearer " + Cookies.get("token"));

    const options = {
      method: "GET",
      headers: headers,
    };

    try {
      const response = await fetch(
        `https://www.smart-lend.com/api/loan/loanRequest/viewLoanRequestDetail?loan_id=${loan_id}`,
        options
      );

      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }

      const data = await response.json();
      setLoanDetails(data);
    } catch (error) {
      console.error(error);
    }
  };
  const [modalStates, setModalStates] = useState({});

  useEffect(() => {
    const initialStates = {};
    data.forEach((item) => {
      initialStates[item.repay_id] = false;
    });
    setModalStates(initialStates);
  }, [data]);

  const [open, setOpen] = useState(false);
  const [openLenderId, setOpenLenderId] = useState(null);

  const showModal = (repay_id, event, lender_id) => {
    event.preventDefault();
    setOpenLenderId(lender_id);
    console.log("repay_id modal", repay_id);
    setModalStates((prevStates) => ({
      ...prevStates,
      [repay_id]: true,
    }));
  };

  const handleMakePayment = async (repay_id, lender_id) => {
    console.log("value of repay_id", repay_id);

    const headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Authorization", "Bearer " + Cookies.get("token"));

    const options = {
      method: "GET",
      headers: headers,
    };

    try {
      const response = await fetch(
        `https://www.smart-lend.com/api/loan/makePayment?repay_id=${repay_id}&lender_id=${lender_id}`,
        options
      );

      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }

      const data = await response.json();
      setMakePayment(data);

      // Display the message from the Ant Design library
      message.success(data.message);

      const headers = new Headers();
      headers.append("Content-Type", "application/json");
      headers.append("Authorization", "Bearer " + Cookies.get("token"));

      try {
        const response = await fetch(
          "https://www.smart-lend.com/api/loan/ongoingLoan/viewOngoingLoan",
          options
        );

        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }

        const data = await response.json();

        setSummary(data["Ongoing Loan"]);
      } catch (error) {
        console.error(error);
      }

      // If the payment was successful
      // if(data.message === "Payment made successfully!") {
      //   try {
      //     let item = {
      //       user_id: user_id,
      //       channel: "system",
      //       subject: "Lender offer",
      //       message: "Lender had make an  offer",
      //     };
      //     const response = await fetch(
      //       "https://www.smart-lend.com/api/user/notification/sendNotification",
      //       {
      //         method: "POST",
      //         headers: {
      //           "Content-Type": "application/json",
      //           Authorization: "Bearer " + Cookies.get("token"),
      //         },
      //         body: JSON.stringify(item),
      //       }
      //     );
      //     const data = await response.json();
      //     console.log("Offer created:", data);
      //   } catch (error) {
      //     console.error("Error creating offer:", error);
      //   }
      // }

      if (
        data.message === "Payment made successfully!" ||
        "Payment has already been made for this repayment."
      ) {
        setRefreshData((prevState) => !prevState); // Toggle the state
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleLoanAmountChange = (e) => {
    setLoanAmount(e.target.value);
  };

  const handleGridPath = () => {
    // history.push('../loan-request-grid')
  };

  const handleListPath = () => {
    history.push("../loan-request");
  };

  const handleInterestRateChange = (e) => {
    setInterestRate(e.target.value);
  };

  const handleLoanPeriodChange = (e) => {
    setLoanPeriod(e.target.value);
  };

  const handleLoanTypeChange = (e) => {
    setLoanType(e.target.value);
  };

  const isWithinSevenDays = (repayDueDate) => {
    const today = new Date();
    const dueDate = new Date(repayDueDate);

    // Calculate the difference in milliseconds
    const differenceInMs = dueDate - today;

    // Calculate the difference in days
    const differenceInDays = differenceInMs / (1000 * 60 * 60 * 24);

    // Check if the due date is within 7 days from today
    console.log(differenceInDays);
    return differenceInDays <= 7;
  };

  const handleMakeOffer = async (loan_id) => {
    console.log("loanId value in handleMakeOffer", loan_id); // Debug statement
    // rest of the code
    try {
      let path = "";
      let item = {
        loan_id,
        offer_amount: parseFloat(offer_amount),
        offer_interest_rate: parseFloat(offer_interest_rate),
        offer_period: parseInt(offer_period),
        type,
        offer_principal: parseFloat(offer_principal),
        offer_monthly_installment: parseFloat(offer_monthly_installment),
        offer_revenue: parseFloat(offer_revenue),
        total_admin_fee: parseFloat(total_admin_fee),
        admin_fee: parseFloat(admin_fee),
      };
      const response = await fetch(
        "https://www.smart-lend.com/api/loan/createLoan",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + Cookies.get("token"),
          },
          body: JSON.stringify(item),
        }
      );
      const data = await response.json();
      path = "/pending-acceptance";

      console.log("Offer created:", data);
      return history.push(path);
      // Update your UI or close the modal
    } catch (error) {
      console.error("Error creating offer:", error);
    }
  };
  const buttonStyleExpress = {
    fontFamily: "Poppins, sans-serif",
    fontWeight: "600",
    fontSize: "15px",
    color: "#FFFFFF",
    textAlign: "center",
    background: "#FED065",
    border: "none",
    borderRadius: "1000px",
    width: "90%",
    height: "40px",
    marginTop: "5px",
    marginBottom: "15px",
  };

  const buttonStyleBorrower = {
    fontFamily: "Poppins, sans-serif",
    fontWeight: "600",
    fontSize: "15px",
    color: "#FFFFFF",
    textAlign: "center",
    background:
      "linear-gradient(90deg, rgba(138, 156, 197, 0.8) 0%, rgba(var(--br-primary-rgb, 21,87,169), 1) 100%)",
    border: "none",
    borderRadius: "1000px",
    width: "90%",
    height: "40px",
    marginTop: "5px",
    marginBottom: "15px",
  };

  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    // Call handleResize initially to set the initial screen width
    handleResize();

    // Add event listener for resize
    window.addEventListener("resize", handleResize);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const MetricItem = ({ label, value, tooltip, onHelpClick }) => (
    <div
      style={{
        position: "relative",
        padding: isMobile ? "10px 10px" : "12px 12px",
        borderRadius: "var(--br-card-radius, 14px)",
        border: "1px solid rgba(148,163,184,0.18)",
        background: "rgba(241,245,249,0.55)",
        minWidth: 0,
      }}
    >
      <div style={{ ...UI.subLabel, fontSize: isMobile ? 11 : 12 }}>
        {label}
      </div>

      <div
        style={{
          fontFamily: "Manrope, sans-serif",
          fontWeight: 900,
          fontSize: isMobile ? 16 : 18,
          color: "rgba(15,23,42,0.88)",
          marginTop: 4,
          lineHeight: 1.1,
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {value}
      </div>

      {tooltip ? (
        <div style={{ position: "absolute", top: 8, right: 8 }}>
          <Tooltip
            overlayStyle={{ zIndex: 9999 }}
            placement="topRight"
            title={tooltip}
          >
            <div
              style={{
                width: 18,
                height: 18,
                borderRadius: 999,
                border: "1px solid rgba(148,163,184,0.45)",
                background: "var(--br-surface, rgba(255,255,255,0.70))",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
              }}
              // onClick={onHelpClick}
            >
              <QuestionOutlined
                style={{ fontSize: 10, color: "rgba(15,23,42,0.55)" }}
              />
            </div>
          </Tooltip>
        </div>
      ) : null}
    </div>
  );

  return (
    <Box m={isMobile ? "4px 0px 20px 0px" : "4px 20px 20px 20px"}>
      <Box
        display={isMobile ? "flex" : "grid"}
        flexDirection={isMobile ? "column" : undefined}
        gridTemplateColumns={isMobile ? undefined : "repeat(12, 1fr)"}
        gridAutoRows={isMobile ? undefined : "140px"}
        gap="20px"
      >
        <Box
          sx={{
            ...(isMobile
              ? { width: "100%" }
              : { gridColumn: "span 9", gridRow: "span 2" }),
            ...UI.card,
            overflowY: "auto",
            height: isMobile ? "calc(100dvh - 80px)" : "90vh",
            overflowX: "hidden",
            p: isMobile ? "8px 10px 120px" : "12px 16px 140px",
            background: "var(--br-surface, rgba(255,255,255,0.35))",
            borderRadius: "var(--br-card-radius, 22px)",
          }}
        >
          {/* LOAN BALANCE HEADER */}
          <div className="sl-borrower-balance-header"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "10px 10px 6px 10px",
            }}
          >
            <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
              <div style={UI.headerTitle}>Loan Balance</div>
              <div style={{ ...UI.subLabel, fontSize: 12 }}>
                Overview of your latest loans & repayments
              </div>
            </div>

            <button
              className="all_button"
              style={{
                ...UI.headerAction,
                ...(hoveredApplyNow ? UI.headerActionHover : {}),
                background: `linear-gradient(135deg, var(--br-primary, rgb(14, 90, 165)) 0%, rgb(109, 92, 246) 120%)`,
                color: "white",
                padding: isMobile ? "5px 15px" : "8px 35px",
              }}
              onClick={(event) => handleApplyLoan(event)}
              onMouseEnter={() => setHoveredApplyNow(true)}
              onMouseLeave={() => setHoveredApplyNow(false)}
            >
              Apply Now
            </button>
          </div>

          {/* LOAN BALANCE VALUE + METRICS */}
          <div
            className="sl-borrower-balance-summary"
            style={{ ...UI.cardSoft, padding: 14, margin: "6px 10px 0 10px" }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: isMobile ? "column" : "row",
                justifyContent: "space-between",
                alignItems: isMobile ? "flex-start" : "center",
                gap: isMobile ? 10 : 0,
              }}
            >
              <div style={{ width: isMobile ? "100%" : "35%" }}>
                <div
                  style={{
                    fontFamily: "Manrope, sans-serif",
                    fontWeight: 900,
                    fontSize: isMobile ? 30 : 38,
                    color: "rgba(15,23,42,0.88)",
                    letterSpacing: "-0.4px",
                    lineHeight: 1.05,
                  }}
                >
                  {totalLoanBalance
                    ? totalLoanBalance.toLocaleString("en-US", {
                        style: "currency",
                        currency: "SGD",
                      })
                    : "$0.00"}
                </div>
              </div>

              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: isMobile
                    ? "1fr 1fr"
                    : "repeat(3, 180px)",
                  gap: isMobile ? 10 : 18,
                  justifyContent: isMobile ? "stretch" : "flex-end",
                  width: isMobile ? "100%" : 700,
                }}
              >
                <MetricItem
                  label="Total Loan"
                  value={totalLoan || "-"}
                  tooltip="This represents the total loan of the latest loan taken up. Click to show all loans and view detailed information."
                  // onHelpClick={(e) => handleAcceptedLoan(e)}
                />

                <MetricItem
                  label="Remaining Term"
                  value={
                    Number.isFinite(+sumMaxRemainingTerm)
                      ? `${sumMaxRemainingTerm} mo.`
                      : "-"
                  }
                  tooltip="This represents the remaining duration of the latest loan taken up. Click to show all loans and view detailed information."
                  // onHelpClick={(e) => handleAcceptedLoan(e)}
                />

                <MetricItem
                  label="Current Interest"
                  value={
                    totalCountInterestRate ? `${totalCountInterestRate} %` : "-"
                  }
                  tooltip="This represents the interest rate of the latest loan taken up. Click to show all loans and view details."
                  // onHelpClick={(e) => handleAcceptedLoan(e)}
                />
              </div>
            </div>

            {/* CHART GRID */}
            <div className="sl-borrower-chart-grid"
              style={{
                display: "flex",
                flexWrap: "wrap",
                width: "100%",
                marginTop: 14,
                gap: 10,
              }}
            >
              <div
                style={{
                  width: isMobile ? "calc(50% - 5px)" : "calc(25% - 8px)",
                }}
              >
                <ContainerPieChart />
              </div>
              <div
                style={{
                  width: isMobile ? "calc(50% - 5px)" : "calc(25% - 8px)",
                }}
              >
                <ContainerLineChart />
              </div>
              <div
                style={{
                  width: isMobile ? "calc(50% - 5px)" : "calc(25% - 8px)",
                }}
              >
                <ContainerPrincipalPaid />
              </div>
              <div
                style={{
                  width: isMobile ? "calc(50% - 5px)" : "calc(25% - 8px)",
                }}
              >
                <ContainerInterestPaid />
              </div>
            </div>
          </div>

          {/* ACCEPTED LOAN */}
          <div style={{ marginTop: 18 }}>
            <div style={{ padding: "8px 10px 6px 10px" }}>
              <div style={UI.headerTitle}>Accepted Loan</div>
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "flex-start", // ✅ keeps cards aligned at top
                overflowX: "auto",
                width: "100%",
                gap: 12,
                padding: "10px",
              }}
            >
              {acceptedLoanData && acceptedLoanData.length > 0 ? (
                acceptedLoanData.map((item, index) => (
                  <div
                    key={index}
                    style={{
                      flex: "0 0 auto",
                      width: isMobile ? "92%" : 240, // ✅ consistent card width
                    }}
                  >
                    <div style={{ ...UI.cardSoft, padding: 14 }}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "flex-start",
                          gap: 10,
                          marginBottom: 10,
                        }}
                      >
                        <div style={{ minWidth: 0 }}>
                          <div style={{ ...UI.subLabel, fontSize: 11 }}>
                            Loan ID
                          </div>
                          <div
                            style={{
                              fontFamily: "Manrope, sans-serif",
                              fontWeight: 900,
                              fontSize: 16,
                              color: "rgba(15,23,42,0.88)",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            }}
                          >
                            {item.loan_id || "—"}
                          </div>
                        </div>

                        <div
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            padding: "6px 10px",
                            borderRadius: 999,
                            fontFamily: "Manrope, sans-serif",
                            fontWeight: 900,
                            fontSize: 12,
                            background:
                              item.status === "done"
                                ? "rgba(16,185,129,0.14)"
                                : "rgba(245,158,11,0.14)",
                            color:
                              item.status === "done"
                                ? "rgba(16,185,129,0.95)"
                                : "rgba(245,158,11,0.95)",
                            border: "1px solid rgba(148,163,184,0.20)",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {item.status
                            ? item.status.charAt(0).toUpperCase() +
                              item.status.slice(1)
                            : "—"}
                        </div>
                      </div>

                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: "1fr 1fr",
                          gap: 10,
                        }}
                      >
                        <div>
                          <div style={{ ...UI.subLabel, fontSize: 11 }}>
                            Loan Amount
                          </div>
                          <div style={{ ...UI.value, fontSize: 14 }}>
                            {Number.isFinite(+item.amount)
                              ? (+item.amount).toLocaleString("en-US", {
                                  style: "currency",
                                  currency: "SGD",
                                })
                              : "—"}
                          </div>
                        </div>

                        <div>
                          <div style={{ ...UI.subLabel, fontSize: 11 }}>
                            Monthly
                          </div>
                          <div style={{ ...UI.value, fontSize: 14 }}>
                            {Number.isFinite(+item.monthly_installment)
                              ? (+item.monthly_installment).toLocaleString(
                                  "en-US",
                                  {
                                    style: "currency",
                                    currency: "SGD",
                                  }
                                )
                              : "—"}
                          </div>
                        </div>

                        <div>
                          <div style={{ ...UI.subLabel, fontSize: 11 }}>
                            Period
                          </div>
                          <div style={{ ...UI.value, fontSize: 14 }}>
                            {item.period ? `${item.period} Months` : "—"}
                          </div>
                        </div>

                        <div>
                          <div style={{ ...UI.subLabel, fontSize: 11 }}>
                            Interest
                          </div>
                          <div style={{ ...UI.value, fontSize: 14 }}>
                            {Number.isFinite(+item.interest_rate)
                              ? `${+item.interest_rate * 100} %`
                              : "—"}
                          </div>
                        </div>

                        <div style={{ gridColumn: "1 / -1" }}>
                          <div style={{ ...UI.subLabel, fontSize: 11 }}>
                            Created At
                          </div>
                          <div style={{ ...UI.value, fontSize: 14 }}>
                            {item.created_at
                              ? formatDate(item.created_at)
                              : "—"}
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* ✅ keep your modal block exactly as you already have it */}
                    <Modal
                      width="50vw"
                      style={{ backgroundColor: "rgba(0, 0, 0, 0)" }}
                      open={modalStates[item.loan_id]}
                      onCancel={() => {
                        setModalStates((prevStates) => ({
                          ...prevStates,
                          [item.loan_id]: false,
                        }));
                        resetLoanDetail();
                        setStatusMessage({ message: "", color: "" });
                      }}
                      footer={[
                        <React.Fragment key="footer-elements">
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              marginTop: "25px",
                            }}
                          >
                            <Button
                              type="primary"
                              style={{
                                background: "#0DC45C",
                                borderRadius: "var(--br-card-radius, 20px)",
                                width: "15%",
                              }}
                              onClick={() => {
                                handleAcceptOffer(item.loan_id);
                              }}
                            >
                              Accept Offer
                            </Button>
                          </div>
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              marginTop: "10px",
                              color: statusMessage.color,
                            }}
                          >
                            <p>{statusMessage.message}</p>
                          </div>
                        </React.Fragment>,
                      ]}
                    >
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          marginTop: 16,
                          borderRadius: "10px",
                        }}
                      >
                        <div style={{ flex: 1 }}>
                          <label
                            htmlFor="offer_amount"
                            style={{
                              fontFamily: "Poppins, sans-serif",
                              fontWeight: "600",
                              fontSize: "40px",
                              color: "var(--br-primary, #0E5AA5)",
                            }}
                          >
                            Offered Loan
                          </label>
                          <TableOfferedLoan
                            loan_id={item.loan_id}
                            onRowClick={(loan_id, offer_id) =>
                              handleRowClick(loan_id, offer_id)
                            }
                          />
                        </div>
                      </div>
                      <hr />
                      {offeredLoanDetail && offeredLoanDetail.length > 0 ? (
                        <LoanDetails offeredLoanDetail={offeredLoanDetail} />
                      ) : (
                        <h5>
                          Please click on the table row to display the Loan
                          Details
                        </h5>
                      )}
                    </Modal>
                  </div>
                ))
              ) : (
                <div style={{ width: "100%", padding: "10px" }}>
                  <div
                    style={{
                      ...UI.cardSoft,
                      height: 140,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      fontFamily: "Manrope, sans-serif",
                      fontSize: "0.85em",
                      fontWeight: 800,
                      color: "rgba(15,23,42,0.45)",
                    }}
                  >
                    No Loan Application Data
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* UPCOMING PAYMENT */}
          <div style={{ marginTop: 24 }}>
            <div style={{ padding: "8px 10px 6px 10px" }}>
              <div style={UI.headerTitle}>Upcoming Payment</div>
            </div>

            <div
              style={{
                padding: "10px",
                width: "100%",
              }}
            >
              <div
                style={{
                  ...UI.cardSoft,
                  padding: 12,
                  minHeight: 160, // ✅ keeps section visually stable
                }}
              >
                {dataSummary &&
                dataSummary.some((loan) =>
                  loan.loan?.some((item) =>
                    isWithinSevenDays(formatDate(item.repay_due_date))
                  )
                ) ? (
                  <div
                    style={{
                      display: "flex",
                      gap: 12,
                      overflowX: "auto",
                    }}
                  >
                    {dataSummary.map((loanItem) =>
                      loanItem.loan
                        .filter((item) =>
                          isWithinSevenDays(formatDate(item.repay_due_date))
                        )
                        .map((item, index) => (
                          <div
                            key={index}
                            style={{
                              flex: "0 0 auto",
                              width: isMobile ? "92%" : 420,
                            }}
                          >
                            <div style={{ ...UI.cardSoft, padding: 14 }}>
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  marginBottom: 10,
                                  alignItems: "flex-start",
                                }}
                              >
                                <div>
                                  <div style={UI.subLabel}>Due Date</div>
                                  <div style={UI.value}>
                                    {item.repay_due_date
                                      ? formatDate(item.repay_due_date)
                                      : "—"}
                                  </div>
                                </div>

                                <div
                                  style={{
                                    padding: "6px 12px",
                                    borderRadius: 999,
                                    fontFamily: "Manrope, sans-serif",
                                    fontWeight: 900,
                                    fontSize: 12,
                                    background: "rgba(245,158,11,0.14)",
                                    color: "rgba(245,158,11,0.95)",
                                    border: "1px solid rgba(148,163,184,0.20)",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  Upcoming
                                </div>
                              </div>

                              <div
                                style={{
                                  display: "grid",
                                  gridTemplateColumns: "1fr 1fr",
                                  gap: 10,
                                  marginBottom: 10,
                                }}
                              >
                                <div>
                                  <div style={UI.subLabel}>Principal</div>
                                  <div style={UI.value}>
                                    {Number.isFinite(+item.repay_total_amount)
                                      ? (+item.repay_total_amount).toLocaleString(
                                          "en-US",
                                          { style: "currency", currency: "SGD" }
                                        )
                                      : "—"}
                                  </div>
                                </div>

                                <div>
                                  <div style={UI.subLabel}>Interest</div>
                                  <div style={UI.value}>
                                    {Number.isFinite(+item.repay_interest)
                                      ? (+item.repay_interest).toLocaleString(
                                          "en-US",
                                          {
                                            style: "currency",
                                            currency: "SGD",
                                          }
                                        )
                                      : "—"}
                                  </div>
                                </div>
                              </div>

                              <div>
                                <div style={UI.subLabel}>Payment Account</div>
                                <div
                                  style={{
                                    fontFamily: "Manrope, sans-serif",
                                    fontWeight: 700,
                                    fontSize: 13,
                                    color: "rgba(15,23,42,0.75)",
                                  }}
                                >
                                  {item.bank_name || "—"} ·{" "}
                                  {item.bank_account_no || "—"}
                                </div>
                              </div>
                            </div>
                          </div>
                        ))
                    )}
                  </div>
                ) : (
                  /* ✅ CLEAN EMPTY STATE */
                  <div
                    style={{
                      height: "100%",
                      minHeight: 140,
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: 8,
                      fontFamily: "Manrope, sans-serif",
                    }}
                  >
                    <div
                      style={{
                        fontSize: 14,
                        fontWeight: 900,
                        color: "rgba(15,23,42,0.55)",
                      }}
                    >
                      No upcoming payments
                    </div>
                    <div
                      style={{
                        fontSize: 12,
                        fontWeight: 700,
                        color: "rgba(15,23,42,0.35)",
                        textAlign: "center",
                        maxWidth: 360,
                      }}
                    >
                      You’re all caught up 🎉 Your next repayment will appear
                      here when it’s scheduled.
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* TRANSACTION HISTORY */}
          <div style={{ marginTop: 10 }}>
            <div style={{ padding: "8px 10px 6px 10px" }}>
              <div style={UI.headerTitle}>Transaction History</div>
            </div>

            <div style={{ padding: "10px" }}>
              <div style={{ ...UI.cardSoft, padding: 12 }}>
                {/* Shared grid definition (keeps header + rows aligned) */}
                {(() => {
                  const rows =
                    (data && data.length > 0
                      ? showAllTransactions
                        ? data
                        : data.slice(0, 3)
                      : []) || [];

                  const hasAmountCol =
                    window.innerWidth >= 1200 &&
                    rows.some((r) => Number.isFinite(+r?.repay_total_amount));

                  const hasDateCol = rows.some((r) => !!r?.repay_date);
                  const hasLenderCol = rows.some((r) => !!r?.lender_name);

                  // Always keep Status column
                  const gridTemplateColumns =
                    window.innerWidth < 1200
                      ? "2fr 1fr" // mobile: Name+meta | Status
                      : hasAmountCol
                      ? "2fr 1.4fr 1fr 0.9fr" // Lender | Date | Amount | Status
                      : "2fr 1.6fr 0.9fr"; // Lender | Date | Status (Amount hidden)

                  const Cell = ({ align = "left", children }) => (
                    <div
                      style={{
                        textAlign: align,
                        display: "flex",
                        justifyContent:
                          align === "right"
                            ? "flex-end"
                            : align === "center"
                            ? "center"
                            : "flex-start",
                        alignItems: "center",
                        minWidth: 0,
                      }}
                    >
                      {children}
                    </div>
                  );

                  const Text = ({
                    strong = false,
                    children,
                    muted = false,
                  }) => (
                    <div
                      style={{
                        fontFamily: "Manrope, sans-serif",
                        fontWeight: strong ? 900 : 800,
                        fontSize: strong ? 13 : 11,
                        color: muted
                          ? "rgba(15,23,42,0.45)"
                          : "rgba(15,23,42,0.78)",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      {children}
                    </div>
                  );

                  return (
                    <>
                      {/* HEADER */}
                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns,
                          gap: 10,
                          alignItems: "center",
                          background: "rgba(241,245,249,0.80)",
                          border: "1px solid rgba(148,163,184,0.18)",
                          borderRadius: "var(--br-card-radius, 14px)",
                          padding: "12px",
                          marginBottom: 10,
                        }}
                      >
                        <Cell>
                          <Text strong>Lender Name</Text>
                        </Cell>

                        {window.innerWidth < 1200 ? null : (
                          <Cell align="center">
                            <Text strong>Date & Time</Text>
                          </Cell>
                        )}

                        {window.innerWidth < 1200 ? null : hasAmountCol ? (
                          <Cell align="center">
                            <Text strong>Amount</Text>
                          </Cell>
                        ) : null}

                        <Cell
                          align={window.innerWidth < 1200 ? "right" : "center"}
                        >
                          <Text strong>Status</Text>
                        </Cell>
                      </div>

                      {/* ROWS */}
                      {rows && rows.length > 0 ? (
                        rows.map((item, index) => {
                          const lender = item?.lender_name || "—";
                          const dateText = item?.repay_date
                            ? reformatDateString(formatDate(item.repay_date))
                            : "—";
                          const amountText = Number.isFinite(
                            +item?.repay_total_amount
                          )
                            ? (+item.repay_total_amount).toLocaleString(
                                "en-US",
                                {
                                  style: "currency",
                                  currency: "SGD",
                                }
                              )
                            : "—";

                          const statusLabel = repaymentStatusLabel(item);

                          const isDone = isRepaymentSettled(item);

                          return (
                            <div key={index} style={{ marginBottom: 6 }}>
                              <div
                                style={{
                                  display: "grid",
                                  gridTemplateColumns,
                                  gap: 10,
                                  alignItems: "center",
                                  padding: "10px 12px",
                                  borderRadius: 14,
                                }}
                              >
                                <Cell>
                                  <div style={{ minWidth: 0 }}>
                                    <Text strong>{lender}</Text>
                                    <Text muted>{item?.Date || "—"}</Text>
                                  </div>
                                </Cell>

                                {window.innerWidth < 1200 ? null : (
                                  <Cell align="center">
                                    <Text strong>{dateText}</Text>
                                  </Cell>
                                )}

                                {window.innerWidth <
                                1200 ? null : hasAmountCol ? (
                                  <Cell align="center">
                                    <Text strong>{amountText}</Text>
                                  </Cell>
                                ) : null}

                                <Cell
                                  align={
                                    window.innerWidth < 1200
                                      ? "right"
                                      : "center"
                                  }
                                >
                                  <div
                                    style={{
                                      display: "inline-flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      padding: "6px 12px",
                                      borderRadius: 999,
                                      fontFamily: "Manrope, sans-serif",
                                      fontWeight: 900,
                                      fontSize: 12,
                                      background: isDone
                                        ? "rgba(16,185,129,0.14)"
                                        : "rgba(245,158,11,0.14)",
                                      color: isDone
                                        ? "rgba(16,185,129,0.95)"
                                        : "rgba(245,158,11,0.95)",
                                      border:
                                        "1px solid rgba(148,163,184,0.20)",
                                      minWidth: 92,
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    {statusLabel}
                                  </div>
                                </Cell>
                              </div>

                              {index !== rows.length - 1 ? (
                                <div
                                  style={{
                                    height: 1,
                                    background: "rgba(148,163,184,0.22)",
                                    margin: "6px 8px 0 8px",
                                  }}
                                />
                              ) : null}
                            </div>
                          );
                        })
                      ) : (
                        <div
                          style={{
                            height: 150,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            fontFamily: "Manrope, sans-serif",
                            fontSize: isMobile ? 12 : 16,
                            fontWeight: 800,
                            color: "rgba(15,23,42,0.45)",
                          }}
                        >
                          No transaction data
                        </div>
                      )}

                      {/* VIEW ALL / LESS */}
                      {data && data.length > 3 && (
                        <div
                          style={{
                            marginTop: 10,
                            background: "rgba(241,245,249,0.80)",
                            border: "1px solid rgba(148,163,184,0.18)",
                            borderRadius: "var(--br-card-radius, 14px)",
                            padding: "12px",
                            cursor: "pointer",
                            textAlign: "center",
                            fontFamily: "Manrope, sans-serif",
                            fontWeight: 900,
                            fontSize: 12,
                            color: "rgba(15,23,42,0.70)",
                          }}
                          onClick={() =>
                            setShowAllTransactions(!showAllTransactions)
                          }
                        >
                          {showAllTransactions
                            ? "View Less Transactions"
                            : "View All Transactions"}
                        </div>
                      )}
                    </>
                  );
                })()}
              </div>
            </div>
          </div>
        </Box>

        {/* RIGHT PANEL (DESKTOP) */}
        {!isMobile ? (
          <Box
            gridColumn="span 3"
            gridRow="span 2"
            overflow="auto"
            height="90vh"
          >
            <Box
              opacity="1.00"
              display="flex"
              alignItems="center"
              justifyContent="center"
              style={{ ...UI.card, padding: 10 }}
            >
              <DashboardAds />
            </Box>

            <Box
              style={{
                marginTop: 14,
                ...UI.card,
                padding: 12,
                background: "var(--br-surface, rgba(255,255,255,0.42))",
              }}
            >
              <div style={{ padding: "6px 6px 10px 6px" }}>
                <div style={UI.headerTitle}>Recent Activities</div>
              </div>

              {dataActivityLog && dataActivityLog.length > 0 ? (
                dataActivityLog.slice(0, 6).map((item, index) => (
                  <div
                    key={index}
                    style={{
                      opacity:
                        index === 4
                          ? 0.6
                          : index === 5
                          ? 0.25
                          : index === 3
                          ? 0.9
                          : 1,
                      transitionDelay: `${index * 0.1}s`,
                    }}
                  >
                    <ContainerActivity
                      title={
                        item.user_id[0] === "L"
                          ? item.principal_name
                          : item.entity_name
                          ? item.entity_name
                          : item.principal_name || "-"
                      }
                      subtitle={item.description || "-"}
                    />
                  </div>
                ))
              ) : (
                <div
                  style={{
                    ...UI.cardSoft,
                    height: 260,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    fontFamily: "Manrope, sans-serif",
                    fontSize: "0.85em",
                    fontWeight: 800,
                    color: "rgba(15,23,42,0.45)",
                  }}
                >
                  No recent activities
                </div>
              )}
            </Box>
          </Box>
        ) : null}
      </Box>
    </Box>
  );
};

export default Dashboard;
